import React, { useEffect, useState } from 'react';
import { FiMaximize2, FiMinimize2 } from 'react-icons/fi';
import { useAppShellHeaderOffset } from './useAppShellHeaderOffset';

/**
 * Player + playlist: side-by-side on desktop, stacked on mobile.
 * Playlist can expand to use the full area below the app header (mobile page or modal sheet).
 */
export default function AudioPlayerSessionLayout({
  player,
  playlist,
  className = '',
  layoutContext = 'modal',
  playlistExpanded: playlistExpandedProp,
  onPlaylistExpandedChange,
  /** When this value changes (e.g. track id), expanded playlist collapses. Do not pass React elements here. */
  playlistResetKey,
}) {
  const [playlistExpandedInternal, setPlaylistExpandedInternal] = useState(false);
  const playlistExpanded = playlistExpandedProp ?? playlistExpandedInternal;
  const setPlaylistExpanded = onPlaylistExpandedChange ?? setPlaylistExpandedInternal;

  useEffect(() => {
    if (playlistResetKey == null) return;
    setPlaylistExpanded(false);
  }, [playlistResetKey, setPlaylistExpanded]);

  const useSheetTop = playlistExpanded && layoutContext === 'page';

  useAppShellHeaderOffset(useSheetTop);

  const rootClass = [
    'audio-player-session',
    playlistExpanded ? 'audio-player-session--playlist-expanded' : '',
    layoutContext === 'page' ? 'audio-player-session--inline' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={rootClass}>
      <div className="audio-player-session__player">{player}</div>
      <div className="audio-player-session__playlist-wrap" data-modal-scroll-port>
        <div className="audio-player-session__playlist-toolbar">
          <span className="audio-player-session__playlist-toolbar-label">Playlist</span>
          <button
            type="button"
            className="audio-player-session__playlist-expand-btn"
            aria-expanded={playlistExpanded}
            onClick={() => setPlaylistExpanded(!playlistExpanded)}
          >
            {playlistExpanded ? (
              <>
                <FiMinimize2 aria-hidden /> Collapse playlist
              </>
            ) : (
              <>
                <FiMaximize2 aria-hidden /> Expand playlist
              </>
            )}
          </button>
        </div>
        <div className="audio-player-session__playlist">{playlist}</div>
      </div>
    </div>
  );
}
